<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #layoutContent>
      <div class="container-fluid card py-10">
        <div class="text-center mb-10">
          <h1 class="fs-2tx fw-bold mb-8">
            {{$t('modules_managment')}}
          </h1>

          <div class="fw-bold fs-2 text-gray-600">
            {{$t('modules_description')}}
          </div>
        </div>
        <div class="row">
          <div class="accordion accordion-icon-toggle" id="kt_accordion_2">
            <div class="mb-5" v-for="(app, index) in apps" :key="index">
                <div class="accordion-header py-3 d-flex" data-bs-toggle="collapse" :data-bs-target="'#kt_accordion_2_item_'+index">
                  <span class="accordion-icon">
                      <i class="fas fa-arrow-right fs-4"><span class="path1"></span><span class="path2"></span></i>
                  </span>
                  <h1 class="fs-4 fw-semibold mb-0 ms-5">{{locale == 'fr' ? app?.title_fr : app?.title_en}}</h1>
                  <span class="haveBorder flex-grow-1 ms-3"></span>
                  <OutlineButton :color="secondaryColor" btn-class="btn-sm ms-5" type="primary" btn-text="install" :isDisabled="loading" @click.prevent="installOrUnistallModule(app?.id)" v-if="!app?.enabled" />
                  <span @click.prevent="installOrUnistallModule(app?.id)" class="text-primary ms-5 fs-3 uninstall-hover" v-else>
                    <span class="install"> <i class="fas fa-check-square text-primary mx-2"></i> <span class="text-primary "> {{ $t('installed') }} </span> </span>
                    <span class="uninstall" style="display: none"> <i class="fas fa-check-square text-danger mx-2"></i> <span class="text-danger"> {{ $t('uninstall') }} </span>  </span>
                  </span>
                </div>
                <div :id="'kt_accordion_2_item_'+index" class="fs-6 collapse ps-10 show" data-bs-parent="#kt_accordion_2">
                  <div class="row">
                    <div v-for="(module, key) in app?.modules" :key="key" class="col-12 col-md-3 col-lg-3">
                      <ModuleCard :module="module" @install="installOrUnistallModule" :app="app?.id" :loading="loading"/>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </template>

  </SubLayout>
</template>

<script setup>
import {computed, onMounted, ref} from "vue";
import OutlineButton from "@/components/OutlineButton.vue"
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import ModuleCard from "@/components/Module/ModuleCard.vue";
import {mapActions, useStore} from "vuex";
import {useLocales} from "@/composables/locales";

const store = useStore()
const {locale} = useLocales()

const title = ref("breadcrumbs.module.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.module.list',
    route: 'modules'
  }
])
const formData = ref({
  app: '',
  modules: []
})
const loading = ref(false)

const apps = computed(() => store.getters['configs/getSuiteApps'])

onMounted( () => {
  loadSuitApps()
})

function loadSuitApps(){
  store.dispatch('configs/loadSuiteApps')
  store.dispatch('moduleAccess/loadModules')
}

function installOrUnistallModule(id, moduleId) {
  formData.value.app = id
  formData.value.modules = []
  if(moduleId){
    formData.value.modules.push(moduleId)
  }

  if(formData.value.app){
    loading.value = true
    store.dispatch('configs/installModules', formData.value)
        .then((response) => {
          loadSuitApps()
          window.toastr['success'](moduleId ? i18n.global.t('notification.module_installed') : i18n.global.t('notification.app_installed'))
        })
        .catch(err => {
        }).finally(() => loading.value = false)
  }
}

</script>

<style scoped>
  .accordion-header {
    display: flex;
    align-items: center;
    padding-right: 10px;
  }

  .accordion-icon {
    display: flex;
    align-items: center;
  }

  .fs-4.fw-semibold {
    flex-shrink: 0;
  }

  .haveBorder {
    border-top: 1px solid rgba(204, 207, 211, 1);
    margin-top: 10px;
    flex-grow: 1;
}

  .OutlineButton {
    margin-left: auto;
  }

  .accordion.accordion-icon-toggle .collapsed .accordion-icon i {
    color: #000 !important;
  }

  .uninstall-hover:hover .install{
    display: none!important;
    transition: .5ms;
  }

  .uninstall-hover:hover .uninstall{
    display: inline-block!important;
    transition: .5ms;
  }

</style>
